var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex pb-10 bg-secondary-background" }, [
    _c("div", { staticClass: "w-9/12" }, [_vm._t("default")], 2),
    _c("div", { staticClass: "w-3/12 ml-8" }, [_vm._t("right-side")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }